<template>
  <div>
    <div v-if="showManage" class="mt-3">
      <PromotionManage
        v-if="showManage"
        v-model="selectedData"
        :type="formType"
        @success="handleFetchData"
        @close="handleCloseManage"
      ></PromotionManage>
    </div>
    <div v-else class="mt-3">
      <v-layout wrap>
        <v-flex xs12 class="pb-3">
          <h1>{{ $t('promotion') }}</h1>
        </v-flex>
        <v-flex xs12 sm6>
          <v-btn dark depressed color="primary" @click="showAdvancedSearch = !showAdvancedSearch">
            <v-icon>search</v-icon>
            &nbsp;
            {{ $t('advanced search') }}&nbsp;
            <em v-if="!showAdvancedSearch" class="fas fa-angle-down" />
            <em v-else class="fas fa-angle-up" />
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 class="text-sm-right text-xs-right">
          <v-btn dark outline color="primary" :loading="loading" @click="handleExportXlsx">
            <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
          </v-btn>
          <v-btn v-if="!showManage" depressed color="primary" @click="handleAddPromotion">
            <span class="fas fa-plus"></span>
            <span class="pl-2">{{ $t('Add') }}{{ $t('promotion') }}</span>
          </v-btn>
        </v-flex>
        <v-flex xs12 class="pt-2">
          <div
            v-if="showAdvancedSearch"
            class="mb-4 py-2"
            style="border: 1px solid #eee; border-radius: 10px; position: relative"
          >
            <v-layout wrap class="form-control">
              <v-flex xs3 px-2>
                <div class="caption">ชื่อโปรโมชั่น:</div>
                <input v-model="filter.name" type="text" placeholder="ชื่อโปรโมชั่น" />
              </v-flex>
              <v-flex xs3 px-2>
                <div class="caption">ประเภทโปรโมชั่น:</div>
                <input v-model="filter.promotion_type" type="text" placeholder="ประเภทโปรโมชั่น" />
              </v-flex>
              <v-flex xs3 px-2>
                <div class="caption">วันที่เริ่มต้น:</div>
                <DatepickerCustomDialog v-model="filter.start_date">
                  <input
                    type="text"
                    :value="handleGetDateFormatted(filter.start_date)"
                    placeholder="วันที่เริ่มต้น"
                    readonly
                  />
                </DatepickerCustomDialog>
              </v-flex>
              <v-flex xs3 px-2>
                <div class="caption">วันที่สิ้นสุด:</div>
                <DatepickerCustomDialog v-model="filter.end_date">
                  <input
                    type="text"
                    :value="handleGetDateFormatted(filter.end_date)"
                    placeholder="วันที่สิ้นสุด"
                    readonly
                  />
                </DatepickerCustomDialog>
              </v-flex>
              <v-flex xs3 px-2>
                <div class="caption">ห้าง:</div>
                <multiselect
                  v-model="filter.department_store"
                  :options="departmentStoreOptions"
                  select-label
                  selected-label
                  placeholder="ทุกห้าง"
                ></multiselect>
              </v-flex>
              <v-flex xs3 px-2>
                <div class="caption">สาขา:</div>
                <multiselect
                  v-model="filter.branch"
                  :options="branchOptions"
                  select-label
                  selected-label
                  placeholder="ทุกสาขา"
                ></multiselect>
              </v-flex>
              <v-flex xs3 px-2>
                <div class="caption">สถานะ:</div>
                <multiselect
                  v-model="filter.is_open"
                  :options="statusOptions"
                  label="label"
                  value="value"
                  select-label
                  selected-label
                  placeholder="ทั้งหมด"
                ></multiselect>
              </v-flex>
              <v-flex xs12 class="text-xs-right">
                <v-btn outline color="grey" @click="handleClearSearch">{{
                  $t('Clear Search')
                }}</v-btn>
                <v-btn depressed color="primary" @click="handleSearch">
                  <em class="fas fa-search mr-1" />
                  {{ $t('Search') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
      <template v-if="dataList && dataList.length > 0">
        <template v-for="(item, index) in dataList">
          <div :key="index" class="pa-3 mb-3" style="border: 1px solid #ccc; border-radius: 4px">
            <v-layout wrap>
              <v-flex xs1 style="display: flex; align-items: center">
                <toggle-button
                  :key="`toggle_${index}`"
                  :value="item.is_open"
                  :color="$vuetify.theme.success"
                  :sync="true"
                  :labels="{ checked: 'ON', unchecked: 'OFF' }"
                  style="display: inline-block"
                  @change="handleChangeStatus(item.id, item.is_open)"
                />
              </v-flex>
              <v-flex xs2>
                <div class="primary--text caption">ระยะเวลา</div>
                <div>
                  {{ item.start_date | dateFormat('DD/MM/YYYY') }} -
                  {{ item.end_date | dateFormat('DD/MM/YYYY') }}
                </div>
              </v-flex>
              <v-flex xs2>
                <div class="primary--text caption">ชื่อโปรโมชั่น</div>
                <div>{{ item.name }}</div>
              </v-flex>
              <v-flex xs2>
                <div class="primary--text caption">ประเภทโปรโมชั่น</div>
                <div>{{ item.promotion_type }}</div>
              </v-flex>
              <v-flex xs2>
                <div class="primary--text caption">ห้าง</div>
                <div>{{ item.department_store ? item.department_store : 'ทุกห้าง' }}</div>
              </v-flex>
              <v-flex xs2>
                <div class="primary--text caption">สาขา</div>
                <div>{{ item.branch ? item.branch : 'ทุกสาขา' }}</div>
              </v-flex>

              <v-flex xs1 class="text-xs-right">
                <v-btn
                  fab
                  small
                  color="warning"
                  outline
                  class="mx-1 my-0"
                  @click="handleEditPromotion(item)"
                  ><v-icon>edit</v-icon></v-btn
                >
                <v-btn
                  fab
                  small
                  color="error"
                  outline
                  class="mx-1 my-0"
                  @click="handleDeletePromotion(item.id)"
                  ><v-icon>delete</v-icon></v-btn
                >
              </v-flex>
            </v-layout>
          </div>
        </template>
        <div class="mt-2">
          <v-pagination
            v-model="pageNumber"
            :total-visible="6"
            :length="pagelength"
            @input="handleChangePage"
          ></v-pagination>
        </div>
      </template>
      <div v-else class="text-xs-center grey lighten-3 py-3" style="border-radius: 10px">
        No data available
      </div>
    </div>
  </div>
</template>

<script>
import toaCrmApi from '@/api/toa-crm'
import { mapGetters } from 'vuex'
import { ToggleButton } from 'vue-js-toggle-button'
import PromotionManage from './PromotionManage'
import * as XLSX from 'xlsx'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import { DATETIME } from '@/constants/datetime.js'

export default {
  components: {
    ToggleButton,
    PromotionManage,
    DatepickerCustomDialog,
    Multiselect
  },
  data() {
    return {
      loading: false,
      dataList: [],
      showManage: false,
      formType: 'add',
      selectedData: null,
      limit: 10,
      offset: 0,
      total: 0,
      pagetmp: 1,
      pageNumber: 1,
      showAdvancedSearch: false,
      isExport: false,
      filter: {
        name: '',
        promotion_type: '',
        start_date: '',
        end_date: '',
        is_open: '',
        department_store: '',
        branch: ''
      },
      statusOptions: [
        {
          label: 'Active',
          value: true
        },
        {
          label: 'Inactive',
          value: false
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    },
    branchMasterData() {
      return this.$store.state.toacrmbranch
    },
    departmentStoreOptions() {
      let options = []
      if (this.branchMasterData) {
        this.branchMasterData.forEach((el) => {
          if (![...options].includes(el.department_store)) {
            options.push(el.department_store)
          }
        })
      }
      return options
    },
    branchOptions() {
      let options = []
      if (this.branchMasterData && this.filter.department_store) {
        const tempOptions = this.branchMasterData.filter((el) => {
          return el.department_store === this.filter.department_store
        })

        tempOptions.forEach((el) => {
          if (![...options].includes(el.branch)) {
            options.push(el.branch)
          }
        })
      }

      return options
    }
  },
  mounted() {
    this.handleGetPromotions()
    this.getMasterDataBranch()
  },

  methods: {
    async handleGetPromotions() {
      const vm = this
      try {
        const response = await vm.getPromotion()
        if (response) {
          vm.dataList = response.data
          vm.total = response.total
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getPromotion() {
      const vm = this
      const limit = vm.isExport ? vm.total : vm.limit
      let data = {
        page_id: vm.selectedBot.pageid,
        limit: limit,
        offset: vm.offset
      }

      if (this.filter.name) {
        Object.assign(data, { name: this.filter.name })
      }
      if (this.filter.promotion_type) {
        Object.assign(data, { promotion_type: this.filter.promotion_type })
      }
      if (this.filter.start_date) {
        Object.assign(data, { start_date: this.filter.start_date })
      }
      if (this.filter.end_date) {
        Object.assign(data, { end_date: this.filter.end_date })
      }
      if (this.filter.department_store) {
        Object.assign(data, { department_store: this.filter.department_store })
      }
      if (this.filter.branch) {
        Object.assign(data, { branch: this.filter.branch })
      }
      if (this.filter.is_open) {
        Object.assign(data, { is_open: this.filter.is_open.value })
      }

      vm.$store.dispatch('loading')
      const response = await toaCrmApi.getPromotion({ config: { params: data } })
      vm.$store.dispatch('loading')

      if (response) {
        return response.data
      } else {
        return null
      }
    },
    async handleExportXlsx() {
      const vm = this
      vm.isExport = true
      const response = await vm.getPromotion()
      const requestData = response.data
      vm.isExport = false

      if (requestData == null) return
      const requests = requestData.map((el) => {
        return {
          id: el.id,
          name: el.name,
          start_date: el.start_date ? vm.handleGetDateFormatted(el.start_date) : '-',
          end_date: el.end_date ? vm.handleGetDateFormatted(el.end_date) : '-',
          promotion_type: el.promotion_type || '-',
          department_store: el.department_store || '-',
          branch: el.branch || '-',
          is_open: el.is_open ? 'ใช้งาน' : 'ไม่ได้ใช้งาน'
        }
      })

      const heading = [
        [
          'รหัสโปรโมชั่น',
          'ชื่อโปรโมชั่น',
          'วันที่เริ่มโปรโมชั่น',
          'วันที่สิ้นสุดโปรโมชั่น',
          'ประเภทโปรโมชั่น',
          'ห้าง',
          'สาขา',
          'สถานะ'
        ]
      ]

      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet([])
      XLSX.utils.sheet_add_aoa(ws, heading)
      XLSX.utils.sheet_add_json(ws, requests, { origin: 'A2', skipHeader: true })
      XLSX.utils.book_append_sheet(wb, ws)
      XLSX.writeFile(wb, `promotion-list.xlsx`)
    },

    async handleChangeStatus(id, status) {
      const vm = this
      try {
        const data = {
          page_id: vm.selectedBot.pageid,
          is_open: !status,
          promotionId: id
        }

        vm.$store.dispatch('loading')
        const response = await toaCrmApi.patchPromotion({ data: data })
        vm.$store.dispatch('loading')

        if (response && response.status == 200) {
          vm.handleGetPromotions()
        }
      } catch (error) {
        console.error(error)
      }
    },

    handleAddPromotion() {
      this.showManage = true
    },
    handleEditPromotion(item) {
      this.formType = 'edit'
      this.selectedData = item
      this.showManage = true
    },
    async handleDeletePromotion(id) {
      const vm = this
      try {
        const result = await vm.$swal.fire({
          type: 'warning',
          text: 'คุณต้องการลบใช่หรือไม่',
          showCancelButton: true,
          cancelButtonText: vm.$t('cancel'),
          confirmButtonText: vm.$t('OK'),
          reverseButtons: true
        })

        if (result.value) {
          vm.$store.dispatch('loading')
          const response = await vm.deletePromotion(id)
          vm.$store.dispatch('loading')

          if (response && response.status === 200) {
            await this.$swal.fire({
              text: 'สำเร็จ',
              type: 'success'
            })
            vm.reset()
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    async deletePromotion(id) {
      const vm = this
      try {
        const response = await toaCrmApi.deletePromotion({
          pageId: vm.selectedBot.pageid,
          promotionId: id
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    handleFetchData() {
      this.showManage = false
      this.handleGetPromotions()
    },
    handleChangePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit
        if (vm.pageNumber != 1) {
          vm.offset + 1
        }
        vm.handleGetPromotions()
      }
    },
    handleCloseManage() {
      this.selectedData = null
      this.showManage = false
      this.formType = 'add'
      this.handleFetchData()
    },
    handleGetDateFormatted(value) {
      return value ? moment(value).format(DATETIME.DATE_FORMAT_DISPLAY) : ''
    },
    handleSearch() {
      this.reset()
    },
    handleClearSearch() {
      this.filter = {
        name: '',
        promotion_type: '',
        start_date: '',
        end_date: '',
        is_open: '',
        branch: '',
        department_store: ''
      }
      this.reset()
      this.handleCloseSearch()
    },
    handleCloseSearch() {
      this.showAdvancedSearch = false
    },
    reset() {
      this.offset = 0
      this.pagetmp = 1
      this.pageNumber = 1
      this.handleGetPromotions()
    },
    async getMasterDataBranch() {
      const vm = this
      try {
        const data = {
          pageid: vm.selectedBot.pageid
        }

        const response = await toaCrmApi.postGetAllBranch({ data: data })

        if (response && response.status === 200) {
          vm.$store.state.toacrmbranch = response.data.data
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/Promotion/Promotion.vue